module.exports = __webpack_public_path__ + "static/media/menu-dots.926e03b9.svg";